export default function() {
    const self = this,
        symplaEventId = self.$route.params.id

    self.resetFormResult()
    self.loadSymplaTokens()

    if (symplaEventId) {
        self.loadSymplaEvent(symplaEventId)
    }
}
